import { CircularProgress, Grid, IconButton, Tooltip, Typography, List, ListItem, ListItemIcon, ListItemText, Button, ListItemSecondaryAction, Hidden, useTheme, useMediaQuery, Link as UILink } from "@material-ui/core";
import React from "react";
import { Data } from "../../framework/data";
import { MatchHeader, MatchStatus, Set } from "../../store/matches/models";
import { Player } from "../../store/players/models";
import PlayersMatches from "./PlayersMatches";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import PostAddIcon from "@material-ui/icons/PostAdd";
import { AppState } from "../../store/reducer";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { loadMyConfirmedMatches, loadMyUnconfirmedMatches } from "../../store/desktop/actions";
import logger from "../../framework/logger";
import { cancelMatch, confirmMatch, submitMatchResult } from "../../store/matches/actions";
import { Alert, AlertTitle } from "@material-ui/lab";
import MatchResultDialog from "../matches/MatchResultDialog";
import { LeagueWithPaymentStatus } from "../../store/leagues/models";
import SportsTennisIcon from '@material-ui/icons/SportsTennis';
import StatsContainer from "../stats/StatsContainer";
import { useAuth0 } from "@auth0/auth0-react";
import EventNoteIcon from '@material-ui/icons/EventNote';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import TableChartIcon from '@material-ui/icons/TableChart';
import { Link } from "react-router-dom";
import { PlayerType } from "../../store/registration/model";
import { Club } from "../../store/clubs/models";
import CancelConfirmationDialog from "../matches/CancelConfirmation";
import OnboardingDialog from "../shell/onboarding/OnboardingDialog";
import { getConfig } from "../../config/configuration";
import { sortBy } from "ramda";

interface DesktopPageProps {
    unconfirmedMatches: Data<MatchHeader[]>;
    confirmedMatches: Data<MatchHeader[]>;
    player: Data<Player>;
    leagues: Data<LeagueWithPaymentStatus[]>;
    clubs: Data<Club[]>;

    loadUnconfirmedMatches: (token: string) => void;
    loadConfirmedMatches: (token: string) => void;

    cancelMatch: (year: string, leagueId: string, matchId: string, token: string, order: string) => void;
    confirmMatch: (year: string, leagueId: string, matchId: string, token: string, order: string) => void;
    submitMatchResult: (sets: Set[], walkover: boolean, year: string, leagueId: string, matchId: string, token: string, order: string) => void;
}

const DesktopPage: React.FC<DesktopPageProps> = ({ unconfirmedMatches, confirmedMatches, player, leagues, loadConfirmedMatches, loadUnconfirmedMatches, cancelMatch, confirmMatch, submitMatchResult, clubs }) => {

    const { getAccessTokenSilently } = useAuth0();

    React.useEffect(() => {

        if (player.type === "LOADED") {
            getAccessTokenSilently().then((token: string) => {
                loadUnconfirmedMatches(token);
                loadConfirmedMatches(token);
            });
        }

    }, [player]);

    const theme = useTheme();
    const isSmallOrUpper = useMediaQuery(theme.breakpoints.up('sm'));

    const [matchResultDialogOpen, setMatchResultDialogOpen] = React.useState<boolean>(false);
    const [matchCancelDialogOpen, setMatchCancelDialogOpen] = React.useState<boolean>(false);
    const [currentMatch, setCurrentMatch] = React.useState<MatchHeader>();
    const [config, setConfig] = React.useState<any>();

    const handleMatchResult = async (success: boolean, sets: Set[], walkover: boolean) => {
        if (success && currentMatch) {
            const token = await getAccessTokenSilently();
            logger.logEvent(`Submitting match result for ${currentMatch.id}`, { match: JSON.stringify(currentMatch), sets: JSON.stringify(sets) });
            submitMatchResult(sets, walkover, leagues.type === "LOADED" ? leagues.value.find(l => l.id === currentMatch.league)?.year || "" : "", currentMatch.league, currentMatch.id, token, config.key === "gorzow" ? "asc" : "desc");
        }
        setMatchResultDialogOpen(false);
    };

    const handleMatchCancelled = async (confirmed: boolean) => {
        if (confirmed && leagues.type === "LOADED" && currentMatch) {
            const token = await getAccessTokenSilently();
            cancelMatch(leagues.value.find(l => l.id === currentMatch.league)?.year || "", currentMatch.league, currentMatch.id, token, config.key === "gorzow" ? "asc" : "desc");
        }

        setMatchCancelDialogOpen(false);
    }

    React.useEffect(() => {
        getConfig().then(setConfig)
    }, [])

    const handleHelpRequested = () => {
        window.location.assign(`mailto:support@smarttennis.pl?subject=Wynik%20meczu%20${currentMatch?.id}&body=Proszę%20podać%20wynik%20meczu`);
    }

    return (<>
        <OnboardingDialog></OnboardingDialog>
        <CancelConfirmationDialog
            open={matchCancelDialogOpen}
            onClosed={(confirmed) => handleMatchCancelled(confirmed)}>
        </CancelConfirmationDialog>
        {
            config?.key === "prod" || config?.key === "local" ? (
                <Alert severity="info" style={{ marginBottom: '16px' }}>
                    <AlertTitle>Ogłoszenia</AlertTitle>
                    <Grid container spacing={2}>
                        <Grid item>

                            <b>Nowy sezon 2026/3 startuje w Krakowie 7 września. Zapraszamy do zapisów.</b><br /><br />
                            <b>Polecaj naszą ligę swoim znajomym - za każde polecenie 150 SmartPunktów!</b><br /><br />
                            <UILink href="https://www.youtube.com/shorts/GzUiwINEMK4" target="_blank" rel="noopener">
                                <b>Video z ostatnich finałów 2026/1</b> </UILink>&nbsp;|&nbsp;&nbsp;
                                <UILink href="https://photos.app.goo.gl/1ivRWjbDK2RaYV7NA" target="_blank" rel="noopener">
                                <b>Zdjęcia z ostatnich finałów 2026/1</b>               </UILink>

                        </Grid>
                        <Grid item>
                            <UILink href="https://www.instagram.com/p/DcUQYV0DpRf/?igsi=MzRlODBiNWFlZA%3D%3D" target="_blank" rel="noopener">
                                <img src="d9cc3c85-3939-42f7-b2eb-0de5befb3b77.jpeg" style={{ width: '100%' }} />
                            </UILink>
                        </Grid>
                    </Grid>
                </Alert>
            ) : (<></>)
        }

        {
            player.type === "LOADED" && player.value && leagues.type === "LOADED" && leagues.value && clubs.type === "LOADED" && clubs.value
                ? (

                    (unconfirmedMatches.type === "LOADED" && confirmedMatches.type === "LOADED") ? (
                        <>
                            <MatchResultDialog
                                open={matchResultDialogOpen}
                                firstPlayer={currentMatch?.firstPlayer}
                                secondPlayer={currentMatch?.secondPlayer}
                                onClosed={(success, sets, walkover) => handleMatchResult(success, sets, walkover)}
                                onHelpRequested={() => handleHelpRequested()}
                                currentPlayer={player.value}
                            ></MatchResultDialog>
                            <Grid container spacing={3}>
                                <Grid item xs={12} lg={6}>
                                    <Typography variant="h6" color="primary">Niepotwierdzone</Typography>


                                    <PlayersMatches
                                        matches={sortBy(x => x.date, unconfirmedMatches.value)}
                                        currentPlayer={player.value}
                                        leagues={leagues.value}
                                        clubs={clubs.value}
                                        actions={(m) => {
                                            const firstAction = m.status === MatchStatus.New && config?.key !== "gorzow" &&
                                                m.createdBy &&
                                                m.createdBy.id !== player.value.id &&
                                                (m.firstPlayer.id === player.value.id ||
                                                    m.secondPlayer.id === player.value.id) ? (
                                                    <Tooltip
                                                        title="Potwierdź, że jesteś umówiony na ten mecz. Zablokowane, jeśli próbujesz zatwierdzić mecz po dacie jest odbycia."
                                                        key="1"
                                                    >
                                                        <IconButton
                                                            size="small"
                                                            disabled={m.date < new Date()}
                                                            onClick={async () => {
                                                                const token = await getAccessTokenSilently();
                                                                logger.logEvent(`Confirming match ${m.id}`, { match: m });
                                                                confirmMatch(leagues.value.find(l => l.id === m.league)?.year || "", m.league, m.id, token, config.key === "gorzow" ? "asc" : "desc");
                                                            }}
                                                        >
                                                            <CheckIcon></CheckIcon>
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <></>
                                                );

                                            const secondAction = config?.key === "gorzow" ? undefined :
                                                (m.status === MatchStatus.New || m.status === MatchStatus.Confirmed) &&
                                                    (m.firstPlayer.id === player.value.id ||
                                                        m.secondPlayer.id === player.value.id) ? (
                                                        <Tooltip title="Anuluj mecz" key="2">
                                                            <IconButton
                                                                size="small"
                                                                onClick={async () => {
                                                                    const token = await getAccessTokenSilently();
                                                                    logger.logEvent(`Cancelling match ${m.id}`, { match: m });

                                                                    if (((m.date.getTime() - new Date().getTime()) / (1000 * 60 * 60)) < 24) {
                                                                        setCurrentMatch(m);
                                                                        setMatchCancelDialogOpen(true);
                                                                    } else {
                                                                        cancelMatch(leagues.value.find(l => l.id === m.league)?.year || "", m.league, m.id, token, config.key === "gorzow" ? "asc" : "desc");
                                                                    }
                                                                }}
                                                            >
                                                                <ClearIcon></ClearIcon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : <></>;

                                            return (<>{firstAction} {secondAction}</>);


                                        }}
                                    >

                                    </PlayersMatches>
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <Typography variant="h6" color="primary">Potwierdzone mecze</Typography>

                                    <PlayersMatches
                                        matches={sortBy(x => x.date, confirmedMatches.value)}
                                        currentPlayer={player.value}
                                        leagues={leagues.value}
                                        clubs={clubs.value}
                                        actions={(m) => {
                                            const firstAction =
                                                m.status === MatchStatus.Confirmed && (m.date <= new Date() || config?.key === "gorzow") &&
                                                    (m.firstPlayer.id === player.value.id ||
                                                        m.secondPlayer.id === player.value.id) ? (
                                                        <Tooltip title="Podaj wynik meczu" key="3">
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    setCurrentMatch(m);
                                                                    setMatchResultDialogOpen(true);
                                                                }}
                                                            >
                                                                <PostAddIcon></PostAddIcon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : <></>;

                                            const secondAction =
                                                (m.status === MatchStatus.New || m.status === MatchStatus.Confirmed) &&
                                                    config?.key !== "gorzow" &&
                                                    (m.firstPlayer.id === player.value.id ||
                                                        m.secondPlayer.id === player.value.id) ? (
                                                        <Tooltip title="Anuluj mecz" key="2">
                                                            <IconButton
                                                                size="small"
                                                                onClick={async () => {
                                                                    const token = await getAccessTokenSilently();
                                                                    logger.logEvent(`Cancelling match ${m.id}`, { match: m });

                                                                    if (((m.date.getTime() - new Date().getTime()) / (1000 * 60 * 60)) < 24) {
                                                                        setCurrentMatch(m);
                                                                        setMatchCancelDialogOpen(true);
                                                                    } else {
                                                                        cancelMatch(leagues.value.find(l => l.id === m.league)?.year || "", m.league, m.id, token, config.key === "gorzow" ? "asc" : "desc");
                                                                    }


                                                                }}
                                                            >
                                                                <ClearIcon></ClearIcon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : <></>;

                                            return (<>{firstAction} {secondAction}</>);


                                        }}
                                    >
                                    </PlayersMatches>
                                </Grid>

                                <Grid item xs={12} lg={8}>
                                    <Typography variant="h6" color="primary">Moje ligi</Typography>

                                    {
                                        (leagues.type === "LOADED") ? (
                                            <List>
                                                {
                                                    leagues.value.sort((a, b) => b.year.localeCompare(a.year)).map(i => (
                                                        <ListItem key={i.id} button style={{ border: '1px solid #e0e0e0', paddingRight: (isSmallOrUpper ? '156px' : '64px') }}>
                                                            <Hidden xsDown>
                                                                <ListItemIcon>
                                                                    <SportsTennisIcon />
                                                                </ListItemIcon>
                                                            </Hidden>
                                                            <ListItemText style={{ maxWidth: 'calc(100% - 64px)' }}>
                                                                {i.name}
                                                            </ListItemText>
                                                            <ListItemSecondaryAction>
                                                                <Button component={Link} to={`/match-offers/${i.year}/${i.id}`}>
                                                                    <EventNoteIcon />
                                                                    <Hidden xsDown>
                                                                        Giełda meczów
                                                                    </Hidden>
                                                                </Button>
                                                                <Button component={Link} to={`/leagues/${i.year}/${i.id}`}>
                                                                    <TableChartIcon />
                                                                    <Hidden xsDown>
                                                                        Tabela
                                                                    </Hidden>
                                                                </Button>
                                                                {
                                                                    i.playerType === PlayerType.TRIAL ? (
                                                                        <Button component={Link} to={`/signup?leagueId=${i.id}&leagueYear=${i.year}`}>
                                                                            <AttachMoneyIcon />
                                                                            <Hidden xsDown>
                                                                                Konto SMART
                                                                    </Hidden>
                                                                        </Button>
                                                                    ) : (<></>)
                                                                }

                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    ))
                                                }

                                            </List>
                                        ) : (
                                                <div style={{
                                                    width: "64px",
                                                    height: "64px",
                                                    marginLeft: "auto",
                                                    marginRight: "auto",
                                                }}>
                                                    <CircularProgress />
                                                </div>
                                            )
                                    }
                                </Grid>
                            </Grid>

                            <StatsContainer playerId={btoa(player.value.id!)}></StatsContainer>
                        </>
                    ) : (
                            <div style={{
                                width: "64px",
                                height: "64px",
                                marginLeft: "auto",
                                marginRight: "auto",
                            }}>
                                <CircularProgress />
                            </div>
                        )
                ) : (
                    <Alert severity="warning">
                        Musisz utworzyć profil zawodnika i zapisać się do wybranej przez siebie ligi aby móc oglądać swoje mecze
                    </Alert>
                )
        }

    </>);
}

const mapStateToProps = (state: AppState) => ({
    unconfirmedMatches: state.desktop.myUnconfirmedMatches,
    confirmedMatches: state.desktop.myConfirmedMatches,
    player: state.player.me,
    leagues: state.leagues.leaguesWithPayments,
    clubs: state.clubs.clubs
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    loadUnconfirmedMatches: (token: string) => dispatch(loadMyUnconfirmedMatches(token)),
    loadConfirmedMatches: (token: string) => dispatch(loadMyConfirmedMatches(token)),

    cancelMatch: (year: string, leagueId: string, matchId: string, token: string, order: string) => dispatch(cancelMatch({ leagueId, matchId, skip: 0, take: 25, year, token, order })),
    confirmMatch: (year: string, leagueId: string, matchId: string, token: string, order: string) => dispatch(confirmMatch({ leagueId, matchId, skip: 0, take: 25, year, token, order })),
    submitMatchResult: (sets: Set[], walkover: boolean, year: string, leagueId: string, matchId: string, token: string, order: string) => dispatch(submitMatchResult({ leagueId, walkover, matchId, skip: 0, take: 25, year, token, sets, order }))
})

export default connect(mapStateToProps, mapDispatchToProps)(DesktopPage);